/**
 * Livecycle Script loader
 */
import { loadScript } from "./script-loader";
interface AppConfiguration {}

const RETURN_TO_QUERY_PARAM = '___lc_return_to';
const Configs = {
  agentSrc: "https://livecycle.dev/agent.js",
  agentScriptId: "lc__agent",
  scriptType: "module" as const,
};

function registerSDKValidateHandler() {
  window?.addEventListener("message", (e) => {
    if (
      e.data !== null &&
      typeof e.data === "object" &&
      "type" in e.data &&
      e.data.type === "livecycle-sdk-check"
    ) {
      e.source?.postMessage(
        {
          type: "livecycle-sdk-check-response",
        },
        {
          targetOrigin: e.origin,
        }
      );
    }
  });
}

const Livecycle = {
  async init(userConfigs: AppConfiguration = {}): Promise<void> {
    try {
      registerSDKValidateHandler();
      if (window.name === "liveEnv"){
        localStorage.removeItem(RETURN_TO_QUERY_PARAM);
        await loadScript(document)(Configs); 
      } else {
        returnToEditorIfNeeded();
      }
    } catch (e) {
      console.debug("failed to init livecycle-agent", e);
    }
  },
};

type ValidLivecycleUrl = string & {_tag: 'ValidLivecycleUrl'};
function validateLivecycleUrl(returnTo: string): returnTo is ValidLivecycleUrl {
  try {
    const url = new URL(returnTo);  
    return url.hostname.match(/.*?livecycle.(dev|xyz)$/) !== null;
  } catch (error) {
    console.debug('failed to use returnTo url', error);
    return false;
  }
}

function returnToEditorIfNeeded() {
  let returnToFromStorage: string | null;
  try {
    returnToFromStorage = localStorage.getItem(RETURN_TO_QUERY_PARAM);
  } catch {
    console.warn('failed to read item from local storage');
    return;
  }
  if (returnToFromStorage && validateLivecycleUrl(returnToFromStorage)) {
    const returnTo = new URL(returnToFromStorage);
    returnTo.searchParams.set(
      'page',
      `${document.location.pathname}${document.location.search}${document.location.hash}`
    );
    localStorage.removeItem(RETURN_TO_QUERY_PARAM);
    const sReturnTo = returnTo.toString();
    window.addEventListener('beforeunload', () => {
      if (returnToFromStorage && document.location.href !== sReturnTo) {
        localStorage.setItem(RETURN_TO_QUERY_PARAM, returnToFromStorage);
      }
    });
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.location.href = sReturnTo;
      }, 2000);
    });
    return;
  }

  const returnTo = new URLSearchParams(window.location.search).get(RETURN_TO_QUERY_PARAM);
  if (returnTo && validateLivecycleUrl(returnTo)) {
    localStorage.setItem(RETURN_TO_QUERY_PARAM, returnTo);
    window.alert(`Hey! 👋
  Please sign in and we'll return you right back to Livecycle`);
    return;
  }
}

export = Livecycle
